import { afterNextRender, Directive, inject } from '@angular/core';
import { NgxDaterangepickerBootstrapDirective } from 'ngx-daterangepicker-bootstrap';

const PICKER_HOST_SELECTOR = 'ngx-daterangepicker-bootstrap';

// O ngx-daterangepicker-bootstrap move o calendário para o <body>, mas quando o input é
// conteúdo projetado do mat-form-field a projeção o devolve para dentro do .mdc-text-field
// (overflow: hidden), deixando o calendário recortado e invisível.
@Directive({
  selector: 'input[ngxDaterangepickerBootstrap][matInput]',
  standalone: true,
})
export class DaterangepickerMatInputDirective {
  private readonly picker = inject(NgxDaterangepickerBootstrapDirective, { self: true });

  constructor() {
    afterNextRender(() => this.attachPickerToBody());
  }

  private attachPickerToBody(): void {
    const pickerContainer: HTMLElement | undefined = this.picker.daterangepicker?.pickerContainer?.nativeElement;
    const pickerHost = pickerContainer?.closest(PICKER_HOST_SELECTOR);

    if (pickerHost && pickerHost.parentElement !== document.body) {
      document.body.appendChild(pickerHost);
    }
  }
}
